import { render, staticRenderFns } from "./CrmModuleLayout.vue?vue&type=template&id=759f01ba"
import script from "./CrmModuleLayout.vue?vue&type=script&lang=js"
export * from "./CrmModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports